import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import {
  getFirestore,
  collection,
  getDocs,
  getDoc,
  setDoc,
  updateDoc,
  doc,
  arrayUnion,
} from "firebase/firestore";
import { initializeApp } from "firebase/app";
import MostRecentEntryInDB from "./MostRecentEntryInDB";
const firebaseConfig = {
  apiKey: "AIzaSyDbL2YiSVlHJZr03t7M_xXMZXKxY6hw2bQ",
  authDomain: "mtc-db-firebase.firebaseapp.com",
  projectId: "mtc-db-firebase",
  storageBucket: "mtc-db-firebase.firebasestorage.app",
  messagingSenderId: "340944976821",
  appId: "1:340944976821:web:1d6df1b2a1022ee44c77fc",
  measurementId: "G-4YT5V8LPYS",
};
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const quarterOptions = ["WQ", "SQ", "FQ"];
const yearOptions = ["24", "25", "26", "27", "28"];

export default function AddNewQuarterToDB() {
  const [quarterPrefix, setQuarterPrefix] = useState("");
  const [year, setYear] = useState("");
  const [maxQuarterId, setMaxQuarterId] = useState(0);
  const [status, setStatus] = useState("");

  const [existingQuarters, setExistingQuarters] = useState<any[]>([]);
  const [selectedQuarterId, setSelectedQuarterId] = useState("");
  const [newWeekName, setNewWeekName] = useState("");
  const [newWeekDate, setNewWeekDate] = useState("");
  const [newSpotifyLink, setNewSpotifyLink] = useState("");

  useEffect(() => {
    const fetchQuarters = async () => {
      const querySnapshot = await getDocs(collection(db, "pickData"));
      const all: any = [];
      let maxId = 0;
      querySnapshot.forEach((docSnap) => {
        const data = docSnap.data();
        all.push({ ...data, id: docSnap.id });
        if (typeof data.quarterId === "number" && data.quarterId > maxId) {
          maxId = data.quarterId;
        }
      });
      setExistingQuarters(all);
      setMaxQuarterId(maxId);
    };
    fetchQuarters();
  }, []);

  const handleAddQuarter = async () => {
    const newQuarterId = maxQuarterId + 1;
    const quarterName = `${quarterPrefix}${year}`;
    const docRef = doc(db, "pickData", newQuarterId.toString());

    const newQuarter = {
      quarterId: newQuarterId,
      quarterName,
      weeks: [],
    };

    try {
      await setDoc(docRef, newQuarter);
      setStatus(`✅ Added new quarter: ${quarterName} (ID: ${newQuarterId})`);
      setMaxQuarterId(newQuarterId);
    } catch (err) {
      console.error(err);
      setStatus("❌ Error adding quarter.");
    }
  };

  const handleAddWeek = async () => {
    if (!selectedQuarterId || !newWeekName || !newWeekDate) {
      return setStatus("❌ All fields required to add a week.");
    }

    const quarterDoc = doc(db, "pickData", selectedQuarterId);

    try {
      const docSnap = await getDoc(quarterDoc);
      let weeks = [];

      if (docSnap.exists()) {
        const data = docSnap.data();
        weeks = data.weeks || [];
      }

      // Get max weekId, default to 0 if none exist
      const maxWeekId = weeks.reduce(
        (max: any, week: any) => Math.max(max, week.weekId || 0),
        0
      );
      const nextWeekId = maxWeekId + 1;

      const newWeek = {
        weekName: newWeekName,
        weekDate: newWeekDate,
        weekId: nextWeekId,
        spotifyPlaylistLink: newSpotifyLink || "",
        picks: [],
      };

      // Add new week using arrayUnion
      await updateDoc(quarterDoc, {
        weeks: [...weeks, newWeek],
      });

      setStatus(
        `✅ Added ${newWeekName} (Week ${nextWeekId}) to quarter with ID of ${selectedQuarterId}`
      );
      setNewWeekName("");
      setNewWeekDate("");
      setNewSpotifyLink("");
    } catch (err) {
      console.error(err);
      setStatus("❌ Failed to add week.");
    }
  };

  return (
    <>
      <div className="faq">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Box>
            <h1>ADD NEW QUARTER</h1>
            <MostRecentEntryInDB comp={"addquarter"} />

            <Box
              sx={{
                display: "flex",
                gap: 2,
                justifyContent: "center",
                mt: 3,
              }}
            >
              <FormControl style={{ minWidth: 100 }} size="small">
                <InputLabel>Quarter</InputLabel>
                <Select
                  value={quarterPrefix}
                  label="Quarter"
                  onChange={(e: SelectChangeEvent) =>
                    setQuarterPrefix(e.target.value)
                  }
                >
                  {quarterOptions.map((q) => (
                    <MenuItem key={q} value={q}>
                      {q}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl style={{ minWidth: 80 }} size="small">
                <InputLabel>Year</InputLabel>
                <Select
                  value={year}
                  label="Year"
                  onChange={(e: SelectChangeEvent) => setYear(e.target.value)}
                >
                  {yearOptions.map((y) => (
                    <MenuItem key={y} value={y}>
                      {y}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Button
              variant="contained"
              onClick={handleAddQuarter}
              sx={{ mt: 3 }}
            >
              Add Quarter
            </Button>
          </Box>
        </div>
        <h4>{status}</h4>
        {status.includes(`✅`) && (
          <h4 style={{ color: "red" }}>
            (REFRESH THE PAGE TO ADD THE FIRST WEEK TO THE NEW QUARTER)
          </h4>
        )}
      </div>
    </>
  );
}
